import type { Sites } from '@studio/types';

const initialSiteFormState: Sites.Components.FormInitialState = {
  url: '',
  branding: {
    mode: 'dark',
  },
  description: '',
  liveWebChannel: '',
  name: '',
  playlists: [],
  isUrlAvailable: true,
};

export default initialSiteFormState;
